import apolloClient from '../../apolloClient';
import invitationsQueries from 'src/gql/queries/invitations';
import invitationMutations from 'src/gql/mutations/invitations';

const getInvitations = async (variables) =>
  apolloClient.query({
    query: invitationsQueries.GET_INVITATIONS,
    fetchPolicy: 'no-cache',
    variables,
  });

const invitateUserToWorkspace = async (variables) =>
  apolloClient.mutate({
    mutation: invitationMutations.INVITE_USER_TO_WORKSPACE,
    fetchPolicy: 'no-cache',
    variables,
  });

const sendCustomerInvitation = async (variables) =>
  apolloClient.mutate({
    mutation: invitationMutations.INVITE_USER_TO_CUSTOMER,
    fetchPolicy: 'no-cache',
    variables,
  });

const sendTreincoAppInvitation = async (variables) =>
  apolloClient.mutate({
    mutation: invitationMutations.INVITE_TREINCO_APP_TO_WORKSPACE,
    fetchPolicy: 'no-cache',
    variables,
  });

const acceptCustomerInvitation = async (variables) =>
  apolloClient.mutate({
    mutation: invitationMutations.ACCEPT_CUSTOMER_INVITATION,
    fetchPolicy: 'no-cache',
    variables,
  });

const cancelInvitationById = async (variables) =>
  apolloClient.mutate({
    mutation: invitationMutations.DELETE_INVITATION,
    fetchPolicy: 'no-cache',
    variables,
  });

const rejectInvitation = async (variables) =>
  apolloClient.mutate({
    mutation: invitationMutations.REJECT_INVITATION,
    fetchPolicy: 'no-cache',
    variables,
  });

export default {
  getInvitations,
  invitateUserToWorkspace,
  sendCustomerInvitation,
  sendTreincoAppInvitation,
  acceptCustomerInvitation,
  cancelInvitationById,
  rejectInvitation,
};
